module.exports = __webpack_public_path__ + "media/src/images/dash-a8bc11b137f7f88cab08d9c17fca8ea0.svg";